import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
  Box,
  Grid,
  Stack,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
  TextField,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import Select from "react-select";
import { Add, Print, ExpandMore, ExpandLess } from "@mui/icons-material";
import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";

import Sidebar from "../sidebar/sidebar";
import { companylogo } from "../../assets/images";
import { BaseUrl } from "../../Environment";
import { getSecureItem } from "../../utilsFunctions";
import { generateDailyCashReport } from "./generateDailyCashReport";

const reportData = {
  reportDate: "21-Jan-2026",
  branch: "Main Branch",
  reportId: "DCR-20260121-0001",
  status: "Draft",

  moneyIn: {
    startingCash: 15000,
    collectionAmount: 8200,
    processingFee: 500,
  },

  moneyOut: {
    disbursementAmount: 12000,
    totalExpenses: 2300,
  },

  expenses: [
    { type: "Travel", remarks: "Field visit", amount: 500 },
    { type: "Stationery", remarks: "Forms printing", amount: 300 },
    { type: "Snacks", remarks: "Staff meeting", amount: 200 },
  ],

  verifiedBy: "",
};

const formatAmount = (val = 0) =>
  Number(val).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const formatPaymentModeLabel = (mode) => {
  if (!mode) return "Unassigned";
  if (mode.toLowerCase() === "unknown") return "Unassigned";
  return mode;
};

const formatAccountLabel = (label) => label || "Unassigned";

export default function CashFlow() {
  const loggedinUser = getSecureItem("loggedinUser");

  const [branchId, setBranchId] = useState(loggedinUser?.branchId || '');
  const [branchData, setBranchData] = useState([]);
  const [branchIdFilter, setBranchIdFilter] = useState('');
  const [type, setType] = useState("weekly");
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [dateAdd, setDateAdd] = useState(moment().format("YYYY-MM-DD"));
  const [minDate, setMinDate] = useState(moment().format("YYYY-MM-DD"));
  const [amount, setAmount] = useState("");
  const [rows, setRows] = useState([]);
  const [showData, setShowData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [expandedBreakdowns, setExpandedBreakdowns] = useState({});

  const isSuperAdmin = loggedinUser?.userType === "superAdmin";

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const buildReportData = async () => {
    try {

      const headers = {
        Authorization: "Bearer " + getSecureItem("token"),
      };

      const res = await axios.get(
        `${BaseUrl}/cashFlow/getOverallCashFlow`,
        {
          params: {
            companyId: loggedinUser?.companyId,
            date,
            type: "weekly",
            branchId: loggedinUser?.userType == "superAdmin" ? branchIdFilter || null : branchIdFilter || loggedinUser?.branchId,
          },
          headers,
        }
      );

      if (res.data?.status) {

        const weeklyRows = res.data.data || [];

        if (!weeklyRows.length) {
          toast.error("No weekly data available");
          return;
        }

        const selectedRow =
          weeklyRows.find(r =>
            moment(r.date).format("YYYY-MM-DD") ===
            moment(date).format("YYYY-MM-DD")
          ) || weeklyRows[0];

        const report = {

          reportDate: moment(date).format("DD-MMM-YYYY"),

          branch: "Main Branch",

          reportId: `DCR-${moment(date).format("YYYYMMDD")}-0001`,

          status: "Generated",

          moneyIn: {
            startingCash: Number(selectedRow.openingCash || 0),
            collectionAmount: Number(selectedRow.collections || 0),
            processingFee: Number(selectedRow.fees?.processFees || 0),
          },

          moneyOut: {
            disbursementAmount: Number(selectedRow.loans || 0),
            totalExpenses: Number(selectedRow.expenses || 0),
          },

          expenses:
            selectedRow.expenseBreakdown?.map(e => ({
              type: e.expenseType,
              remarks: "",
              amount: Number(e.amount),
            })) || [],
        };

        generateDailyCashReport(report);

      }

    } catch (err) {
      console.error(err);
      toast.error("Failed to generate report");
    }
  };

  const fetchBranches = async () => {
    try {
      const token = getSecureItem("token");
      const headers = {
        Authorization: "Bearer " + token,
      };

      const { data } = await axios.get(`${BaseUrl}/branch/getAllBranches`, {
        params: { companyId: loggedinUser?.companyId },
        headers,
      });

      const branchData = loggedinUser?.userType == "superAdmin" ? data?.data : data?.data?.filter((item) => item?.branchId == loggedinUser?.branchId);

      const formattedBranches = (branchData || []).map(item => ({
        label: item.branchName,
        value: item.branchId,
      }));

      setBranchData([
        { label: "Select Branch", value: null },
        ...formattedBranches,
      ]);
    } catch (err) {
      console.error("Fetch Branches Error:", err);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  // const getBranchUsers = async () => {
  //   try {
  //     const headers = {
  //       'Content-Type': 'application/json',
  //       'Authorization': 'Bearer '+ getSecureItem("token")
  //     }
          
  //     const resp = await axios.get(`${BaseUrl}/user/getAllUsers?userName=&companyId=${loggedinUser.companyId}&branchId=${loggedinUser?.userType == "superAdmin" ? branchId : branchId || loggedinUser?.branchId || ''}`,{
  //       headers: headers,
  //     });
  //     const mainData = resp.data.result;
  //     setBranchUsers(mainData?.map((data) => (data?.userId)))
  //     console.log("resp.data.result", resp.data.result);
  //   } catch (error) {
  //     console.log({error});
  //   }
  // }

  // console.log({branchUsers});
  

  // useEffect(() => {
  //   if(branchId){
  //     getBranchUsers();
  //   }
  // }, [branchId])

  /* ==============================
     FETCH CASH FLOW
  ============================== */
  const fetchCashFlow = useCallback(async () => {
    try {
      setLoading(true);
      const headers = {
        Authorization: "Bearer " + getSecureItem("token"),
      };

      const subData = await axios.get(`${BaseUrl}/cashFlow/getCashFlow`, {
        params: {
          companyId: loggedinUser?.companyId,
          branchId: loggedinUser?.userType == "superAdmin" ? branchIdFilter || null : branchIdFilter || loggedinUser?.branchId,
        },
        headers,
      });
      const { firstEntryDate } = subData.data;
      setMinDate(firstEntryDate ? moment(firstEntryDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"));

      const res = await axios.get(`${BaseUrl}/cashFlow/getOverallCashFlow`, {
        params: {
          companyId: loggedinUser?.companyId,
          date,
          type,
          branchId: loggedinUser?.userType == "superAdmin" ? branchIdFilter || null : branchIdFilter || loggedinUser?.branchId,
        },
        headers,
      });

      if (res.data?.status) {
        setRows(res.data.data || []);
        setShowData(res.data.isDataAvailable);

        if (!res.data.isDataAvailable) {
          handleOpenDialog();
        }
      }
    } catch (err) {
      console.error("CashFlow API Error:", err);
    } finally {
      setLoading(false);
    }
  }, [date, type, loggedinUser?.companyId, branchIdFilter]);

  /* ==============================
     ADD CASH FLOW
  ============================== */
  const addCashFlow = useCallback(async () => {
    try {
      setLoading(true);
      const headers = {
        Authorization: "Bearer " + getSecureItem("token"),
      };
      const res = await axios.post(`${BaseUrl}/cashFlow/addCashFlow`, {
        companyId: loggedinUser?.companyId,
        createdByUserId: loggedinUser?.userId,
        newData: {
          amount,
          date: moment(dateAdd).format("YYYY-MM-DD"),
          isAdhoc: "Y",
          branchId: parseInt(branchId) || null
        },
      }, { headers });

      if (res.data?.status) {
        toast.success("Cash Added Successfully", {
          autoClose: 2000,
          hideProgressBar: true,
        });
        setOpenDialog(false);
        setAmount("");
        setDateAdd(moment().format("YYYY-MM-DD"));
        fetchCashFlow();
      }
    } catch (err) {
      console.error("Add CashFlow Error:", err);
    } finally {
      setLoading(false);
    }
  }, [amount, dateAdd, branchId, fetchCashFlow, loggedinUser]);

  useEffect(() => {
    fetchCashFlow();
  }, [fetchCashFlow]);

  const handleDeleteCashFlow = async () => {
    try {
      setLoading(true);

      const token = getSecureItem("token");
      const headers = { Authorization: "Bearer " + token, };
      const res = await axios.delete(`${BaseUrl}/cashFlow/deleteCashFlow?companyId=${loggedinUser.companyId}`,
        { headers, }
      );


      if (res.data?.status) {
        toast.success("Cash Flow Deleted Successfully", {
          autoClose: 2000,
          hideProgressBar: true,
        });

        setRows([]);
        setShowData(false);
        setOpenDeleteDialog(false);
      }
    } catch (err) {
      console.error("Delete CashFlow Error:", err);
    } finally {
      setLoading(false);
    }
  };

  /* ==============================
     TABLE HEADERS (DERIVED)
  ============================== */
  const columns = useMemo(() => {
    if (!rows.length) return [];
    if (type === "weekly") return rows.map((r) => r.date);
    if (type === "monthly") return rows.map((r) => `${r.from} - ${r.to}`);
    if (type === "yearly") return rows.map((r) => r.month);
    return [];
  }, [rows, type]);

  const useBreakdownKeys = (breakdownField) =>
    useMemo(() => {
      const keys = new Set();
      rows.forEach((r) => {
        Object.keys(r?.[breakdownField] || {}).forEach((k) => keys.add(k));
      });
      return Array.from(keys);
    }, [rows, breakdownField]);

  const paymentModes = useBreakdownKeys("collectionByPaymentMode");
  const loanAccounts = useBreakdownKeys("loanByAccount");
  const otherIncomeAccounts = useBreakdownKeys("otherIncomeByAccount");
  const investmentRepaymentAccounts = useBreakdownKeys("investmentRepaymentByAccount");
  const investedAmountAccounts = useBreakdownKeys("investedAmountByAccount");
  const expenseAccounts = useBreakdownKeys("expenseByAccount");

  const toggleBreakdown = (breakdownField) => {
    setExpandedBreakdowns((prev) => ({
      ...prev,
      [breakdownField]: !prev[breakdownField],
    }));
  };

  const getValueByPath = (obj, path) =>
    path.split(".").reduce((acc, part) => (acc == null ? acc : acc[part]), obj);

  const renderRow = useCallback(
    (label, key) => (
      <TableRow>
        <TableCell className="Fonts">{label}</TableCell>
        {rows.map((r, i) => (
          <TableCell key={i} align="center">
            {formatAmount(getValueByPath(r, key))}
          </TableCell>
        ))}
      </TableRow>
    ),
    [rows]
  );

  const renderExpandableRow = useCallback(
    (
      label,
      valueKey,
      breakdownField,
      subKeys,
      formatSubLabel = (l) => l,
      getSubValue = (row, subKey) => row?.[breakdownField]?.[subKey] || 0
    ) => {
      const isExpanded = !!expandedBreakdowns[breakdownField];

      return (
        <React.Fragment key={breakdownField}>
          <TableRow>
            <TableCell className="Fonts">
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <span>{label}</span>
                {subKeys.length > 0 && (
                  <IconButton
                    size="small"
                    onClick={() => toggleBreakdown(breakdownField)}
                    aria-label={`Toggle ${label} breakdown`}
                  >
                    {isExpanded ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </IconButton>
                )}
              </Stack>
            </TableCell>
            {rows.map((r, i) => (
              <TableCell key={i} align="center">
                {formatAmount(getValueByPath(r, valueKey))}
              </TableCell>
            ))}
          </TableRow>

          {isExpanded &&
            subKeys.map((subKey) => (
              <TableRow key={subKey} sx={{ backgroundColor: "#fafafa" }}>
                <TableCell
                  className="Fonts"
                  sx={{ pl: 4, fontSize: 13, color: "text.secondary" }}
                >
                  {formatSubLabel(subKey)}
                </TableCell>
                {rows.map((r, i) => (
                  <TableCell
                    key={i}
                    align="center"
                    sx={{ fontSize: 13, color: "text.secondary" }}
                  >
                    {formatAmount(getSubValue(r, subKey))}
                  </TableCell>
                ))}
              </TableRow>
            ))}
        </React.Fragment>
      );
    },
    [rows, expandedBreakdowns]
  );

  const feeSubKeys = ["processFees", "revenueFees"];
  const formatFeeLabel = (key) =>
    key === "processFees" ? "Processing Fee" : "Revenue Fee";

  const expenseTypes = useMemo(() => {
    const types = new Set();
    rows.forEach((r) => {
      (r?.expenseBreakdown || []).forEach((e) => {
        if (e?.expenseType) types.add(e.expenseType);
      });
    });
    return Array.from(types);
  }, [rows]);

  const getExpenseAmount = (row, expenseType) =>
    (row?.expenseBreakdown || []).find((e) => e.expenseType === expenseType)
      ?.amount || 0;

  const cashSplitSubKeys = ["cashInHand", "cashInBank"];
  const formatCashSplitLabel = (key) =>
    key === "cashInHand" ? "Cash in Hand" : "Cash in Bank";
  const getCashSplitValue = (row, key) => Number(row?.[key] || 0);

  return (
    <>
      <Sidebar />

      <Box ml={9} height="100vh">
        {/* HEADER */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ background: "#fff", px: 2, height: 70 }}
        >
          <img src={companylogo} width={200} height={40} alt="logo" />
          <Typography fontSize={20} fontWeight="bold">
            Cash Flow Statement
          </Typography>
        </Stack>

        {/* FILTERS */}
        <Paper sx={{ p: 2, m: 2 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <TextField
                type="date"
                label="Select Date"
                fullWidth
                className="Fonts"
                size="small"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  min: minDate,
                }}
              />
            </Grid>

            <Grid
              item
              md={3}
              xs={12}
            >
              <Select
                options={branchData}
                placeholder="Select Branch"
                className="Fonts"
                value={
                  branchIdFilter &&
                  branchData.find((item) => item.value == branchIdFilter)
                }
                onChange={(val) => setBranchIdFilter(val?.value)}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                select
                label="Type"
                fullWidth
                size="small"
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <MenuItem value="weekly">Weekly</MenuItem>
                <MenuItem value="monthly">Monthly</MenuItem>
                <MenuItem value="yearly">Yearly</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} md={12}>
              <Box sx={{ display: "flex", gap: 2, }}>
                <IconButton
                  style={{ backgroundColor: "#eee", padding: 10 }}
                  onClick={buildReportData}
                >
                  <Print />
                </IconButton>
                <Button
                  startIcon={<Add />}
                  color="success"
                  variant="contained"
                  onClick={handleOpenDialog}
                >
                  Add Cash
                </Button>
                {showData && isSuperAdmin && <Button
                  startIcon={<Add />}
                  color="error"
                  variant="contained"
                  onClick={() => setOpenDeleteDialog(true)}
                >
                  Delete Cash Flow
                </Button>}
              </Box>
            </Grid>
          </Grid>
        </Paper>

        {/* TABLE */}
        <Paper sx={{ p: 2, m: 2 }}>
          {loading ? (
            <Stack alignItems="center" py={6}>
              <CircularProgress />
            </Stack>
          ) : (
            showData ? <TableContainer sx={{ overflowX: "auto" }}>
              <Table sx={{ minWidth: columns.length * 180 }}>
                {/* HEADER */}
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f5f9ff" }}>
                    <TableCell />
                    {columns.map((c, i) => (
                      <TableCell
                        key={i}
                        align="center"
                        sx={{
                          fontWeight: 700,
                          color: "#0d47a1",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {c}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {/* INFLOW */}
                  <TableRow sx={{ backgroundColor: "#e8f5e9" }}>
                    <TableCell
                      colSpan={columns.length + 1}
                      sx={{ fontWeight: 800, color: "green" }}
                    >
                      INFLOW
                    </TableCell>
                  </TableRow>

                  {renderRow("Opening Cash", "openingCash")}

                  {renderRow("Manual Cash Entry(Adhoc)", "addcash")}

                  {renderExpandableRow(
                    "Collections",
                    "collections",
                    "collectionByPaymentMode",
                    paymentModes,
                    formatPaymentModeLabel
                  )}

                  {renderExpandableRow(
                    "Fees",
                    "inflowFees",
                    "fees",
                    feeSubKeys,
                    formatFeeLabel
                  )}

                  {renderExpandableRow(
                    "Invested Amount",
                    "investedAmount",
                    "investedAmountByAccount",
                    investedAmountAccounts,
                    formatAccountLabel
                  )}

                  {renderExpandableRow(
                    "Other Income",
                    "otherIncome",
                    "otherIncomeByAccount",
                    otherIncomeAccounts,
                    formatAccountLabel
                  )}

                  {renderRow("Ledger In", "ledgerIn")}

                  <TableRow sx={{ backgroundColor: "#f0fff0" }}>
                    <TableCell sx={{ fontWeight: 700, color: "green" }}>
                      Total In-Flow (A)
                    </TableCell>
                    {rows.map((r, i) => (
                      <TableCell
                        key={i}
                        align="center"
                        sx={{ fontWeight: 700 }}
                      >
                        {formatAmount(r.cashIn)}
                      </TableCell>
                    ))}
                  </TableRow>

                  {/* OUTFLOW */}
                  <TableRow sx={{ backgroundColor: "#fdecea" }}>
                    <TableCell
                      colSpan={columns.length + 1}
                      sx={{ fontWeight: 800, color: "red" }}
                    >
                      OUTFLOW
                    </TableCell>
                  </TableRow>

                  {renderExpandableRow(
                    "Loans",
                    "loans",
                    "loanByAccount",
                    loanAccounts,
                    formatAccountLabel
                  )}

                  {renderRow("Payable Fees", "payableFees")}

                  {renderExpandableRow(
                    "Expenses",
                    "expenses",
                    "expenseByAccount",
                    expenseAccounts,
                    formatAccountLabel
                  )}

                  {renderExpandableRow(
                    "Investment Repayment",
                    "investmentRepayment",
                    "investmentRepaymentByAccount",
                    investmentRepaymentAccounts,
                    formatAccountLabel
                  )}

                  {renderRow("Ledger Out", "ledgerOut")}

                  <TableRow sx={{ backgroundColor: "#fff0f0" }}>
                    <TableCell sx={{ fontWeight: 700, color: "red" }}>
                      Total Out-Flow (B)
                    </TableCell>
                    {rows.map((r, i) => (
                      <TableCell
                        key={i}
                        align="center"
                        sx={{ fontWeight: 700 }}
                      >
                        {formatAmount(r.cashOut)}
                      </TableCell>
                    ))}
                  </TableRow>

                  {/* CLOSING BALANCE */}
                  <TableRow sx={{ backgroundColor: "#e6e6e6" }}>
                    <TableCell sx={{ fontWeight: 800 }}>
                      Total Balance (A - B)
                    </TableCell>
                    {rows.map((r, i) => (
                      <TableCell
                        key={i}
                        align="center"
                        sx={{ fontWeight: 700 }}
                      >
                        {formatAmount(r.closingCash)}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer> : <Typography textAlign="center" fontSize={18} mt={4}>
              No data available for the selected filters.
            </Typography>
          )}
        </Paper>

        {/* ADD CASH FLOW MODAL */}
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogContent>
            <Typography className="Fonts" fontWeight={"bold"}>Please Add Cash in hand Amount to start with</Typography>
            <Typography className="Fonts" >Note: The amount can be added later at anytime</Typography>
            <Stack spacing={2} my={2} minWidth={300}>
              <TextField
                label="Amount"
                type="number"
                fullWidth
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
              <TextField
                type="date"
                label="Select Date"
                fullWidth
                size="small"
                value={dateAdd}
                onChange={(e) => setDateAdd(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
              <Select
                options={branchData}
                isDisabled={(loggedinUser?.company?.planId == 3) ? false : true}
                placeholder="Select Branch"
                value={
                  branchId &&
                  branchData?.find((item) => item.value == branchId)
                }
                onChange={(val) => setBranchId(val?.value)}
              />

              <Stack direction="row" spacing={2} mt={2}>
                <Button variant="outlined" onClick={handleCloseDialog}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  disabled={!amount || amount <= 0}
                  onClick={addCashFlow}
                >
                  Save
                </Button>
              </Stack>
            </Stack>
          </DialogContent>
        </Dialog>

        <Dialog
          open={openDeleteDialog}
          onClose={() => setOpenDeleteDialog(false)}
        >
          <DialogContent>
            <Stack spacing={2} minWidth={350}>
              <Typography fontWeight="bold" color="error">
                Delete Cash Flow Data?
              </Typography>

              <Typography>
                This action cannot be undone. All cash flow records will be permanently removed.
              </Typography>

              <Stack direction="row" spacing={2} justifyContent="flex-end">
                <Button
                  variant="outlined"
                  onClick={() => setOpenDeleteDialog(false)}
                >
                  Cancel
                </Button>

                <Button
                  variant="contained"
                  color="error"
                  onClick={handleDeleteCashFlow}
                >
                  Yes, Delete
                </Button>
              </Stack>
            </Stack>
          </DialogContent>
        </Dialog>
      </Box>
    </>
  );
}